const financialInsuranceRouter = {
  path: '/exportInsurance',
  redirect: '/exportInsurance/index',
  component: () => import('@/layout/orderHeader'),
  children: [
    {
      path: 'index', // 义乌出口信用保险
      name: 'index',
      meta: {
        title: '义乌出口信用保险',
        breadcrumb: {
          name: '首页',
          path: '/',
          isOut: false,
          children: {
            name: '服务专区',
            path: process.env.VUE_APP_MARKET_SERVICE,
            isOut: true,
            children: {
              name: '贸易保险',
              path: '',
              isOut: false
            }
          }
        }
      },
      component: () =>
        import(/* webpackChunkName: "financial-insurance" */ '@/pages/exportInsurance')
    }
  ]
}

export default financialInsuranceRouter
